import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RegistrationStepService } from "../registration-step.service";
import { QuestionRequest } from "../models/question-request.model";
import { MatDialog } from "@angular/material/dialog";
import { LoaderComponent } from "src/app/loader/loader.component";
import { ActionSheetController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: "app-qs-occupation",
  templateUrl: "./qs-occupation.component.html",
  styleUrls: ['../registration-step.component.scss']
})
export class QsOccupationComponent implements OnInit {
  @Input() questionCode: string = 'Q_OCCUPATION';
  @Input() activeLang: string = "";
  questionRequest: QuestionRequest;
  progressSpinnerDialog: any = null;
  @Output() proceedNext = new EventEmitter();
  proceedEnabled: boolean = false;
  dirtyForm: boolean = false;
  errorMessageVisible: boolean = false;
  errorMessage: string = '';
  selectedType: any = "";
  excludedUploadTypes: string[] = ['INDIVIDUAL', 'HUF'];
  uploadFileVisible: boolean = false;
  fileObj: File;
  selectedImage: string = '';
  fileBase64: string | ArrayBuffer = null;
  previewImage: string = '';
  occupations: any[] = [];
  nonEditable: boolean = false;

  constructor(private registrationStepService: RegistrationStepService, private dialog: MatDialog,
    public actionSheetController: ActionSheetController, private translocoService: TranslocoService
  ) { }

  ngOnInit() {
    this.loadOccupation();

    if (localStorage.getItem("editQuestionCode") === this.questionCode) {


      this.displayProgressSpinner();

      this.registrationStepService.fetchQuestionDetail(this.questionCode)
        .subscribe((data) => {

          console.log("Response Answer 👉", data.occupationResponse.answer);
          this.closeProgressSpinner();

          if (data.status === 'SUCCESS') {

            if (data.occupationResponse?.answer) {

              this.selectedType = data.occupationResponse.answer;
             
             this.evaluateProceed();

            } else {
              localStorage.removeItem("editQuestionCode");
              this.proceedNext.emit();
            }

          } else {
            this.registrationStepService.showErrorMessage(data.errorMessage, true);
          }

        }, error => {
          this.closeProgressSpinner();
          this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
        });
    }
  }

  loadOccupation() {
    this.registrationStepService.getOccupationNames().subscribe(res => {

      console.log("API DATA 👉", res);

      // ✅ handle both cases
      this.occupations = res;

    }, err => {
      console.log("API ERROR ❌", err);
    });
  }




  onOccupationChange(event: any) {

    this.selectedType = event.value;

    console.log("Selected 👉", this.selectedType);

    this.proceedEnabled = !!this.selectedType;

  }


  async proceed() {

    if (!this.selectedType || this.selectedType.length === 0) {
      this.registrationStepService.frontendWarningToast("error-mandatory-fields", false);
      return;
    }

    this.displayProgressSpinner();

    this.questionRequest = {
      occupationRequestBody: {
        answer: this.selectedType   // ✅ send CSV
      }
    };

    console.log("FINAL PAYLOAD 👉", this.questionRequest);

    this.registrationStepService.saveQuestion(this.questionCode, this.questionRequest)
      .subscribe((data) => {

        this.closeProgressSpinner();

        if (data.status === 'SUCCESS') {
          localStorage.removeItem("editQuestionCode");
          this.proceedNext.emit();
        } else {
          this.registrationStepService.showErrorMessage(data.errorMessage, true);
        }

      }, error => {
        console.log(error);
        this.closeProgressSpinner();
        this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
      });
  }


  evaluateProceed() {
    this.proceedEnabled = this.selectedType && this.selectedType.length > 0;
    return this.proceedEnabled;
  }



  setFileObj(file: any) {
    this.fileObj = file;
    this.dirtyForm = true;

    const reader = new FileReader();
    reader.readAsDataURL(this.fileObj);

    reader.onload = () => {
      this.fileBase64 = reader.result;
      this.evaluateProceed();
    };
  }

  setSelectedImage(image: string) {
    this.selectedImage = image;
  }

  setPreviewImage(event: any) {
    this.previewImage = event;
  }
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  async closeProgressSpinner() {
    if (this.progressSpinnerDialog) {
      this.progressSpinnerDialog.close();
    }
  }

}